import axios from "axios";
import urls from "../constants/urls";

const api = axios.create({
  // baseURL is not set because urls.js provides absolute URLs.
  // If we refactor urls.js to relative paths, we should set baseURL here.
});

// Since urls.js exports full URLs, we can't easily set a baseURL unless we change urls.js or usage.
// However, we can still use the instance.

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) {
            throw new Error("No refresh token");
        }

        const response = await axios.post(urls.refreshToken, {
            refreshToken: refreshToken
        });

        if (response.status === 200) {
           const { accessToken, refreshToken: newRefreshToken } = response.data;
           
           // Based on guide:
           // const userObj = response.user || response.data?.user;
           // const accessToken = userObj?.accessToken || userObj?.token;
           // const refreshToken = userObj?.refreshToken;
           
           const data = response.data;
           const userObj = data.user || data.response?.user || data;
           const newAccessToken = userObj?.accessToken || userObj?.token;
           const nextRefreshToken = userObj?.refreshToken;

           if (newAccessToken) {
               localStorage.setItem("token", newAccessToken);
               // Update defaults for subsequent calls
               api.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
               // Update the failed request's config
               originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
               
               if (nextRefreshToken) {
                   localStorage.setItem("refreshToken", nextRefreshToken);
               }
               
               // Retry original request with new token
               return api(originalRequest);
           }
        }
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        // Logout
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        localStorage.removeItem("doctor");
        // Redirect to login
        window.location.href = "/iniciar-sesion";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
